import { EGarageType, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectGarageTypeFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const GarageTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectGarageTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleGarageTypesChange = useCallback(
    (newValue: NonEmptyArray<EGarageType> | null) => {
      onChange({ action: 'setGarageTypes', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleGarageTypesChange} />
    </AdvancedFilterRow>
  );
};
